/**
 * Non Post Order Details
 */

// React
import React, { useState, useEffect } from "react";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../../theme";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  IconButton,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useForm } from "react-hook-form";

// Icon
import Icon from "@mdi/react";
import {
  mdiCalendar,
  mdiAccountOutline,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiCityVariantOutline,
  mdiSendCircleOutline,
  mdiWeight,
  mdiRuler,
  mdiCounter,
  mdiPaperRollOutline,
  mdiPackageVariant,
  mdiLoading,
  mdiAccountCircle,
} from "@mdi/js";

// Helper
import {
  translate,
  formaterPhoneNumber,
  uintToString,
  numberWithCommas,
} from "../../../utils/helpers";
import jMoment from "moment-jalaali";
import handleNotfication from "../../../utils/handleNotfication";
import StaticMap from "../../../components/maps/staticMap";

// Type
import { Status } from "../interfaces";
import { mdiText } from "@mdi/js/commonjs/mdi";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import handleError from "../../../utils/handleError";
import MapPosition from "./mapPosition";
import Modal from "../../../components/Modal";
import TPSRepository from "client-sdk/src/Repository/tps-management-repository";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
      "@media (max-width: 768px)": {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    secondDestination: {
      color: "#4aa8ff",
      "&:hover": {
        backgroundColor: "transparent",
        color: "#4594db",
      },
      "& .MuiButton-label": {
        display: "flex",
        justifyContent: "flex-start",
      },
    },
    requestButton: {
      backgroundColor: "#4aa8ff",
      marginTop: "20px",
      width: "100%",
      color: "white",
      "&:hover": {
        backgroundColor: "#4594db",
      },
    },
    requestDetailCard: {
      borderRadius: "10px",
      zIndex: 1000,
      backgroundColor: "white",
      padding: "20px",
      position: "absolute",
      top: "10px",
      left: "10px",
      width: "300px",
      "& > h4": {
        marginTop: 0,
      },
      "& .inputText": {
        margin: "20px 0",
      },
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8A8A8A",
      marginRight: "10px",
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    borderBottom: {
      paddingBottom: "20px",
      borderBottom: "3px solid #ff1111",
    },
    cancelIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.error.main,
      },
    },
    textInput: {
      // width: '25ch',
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    select: {
      "& .MuiInputLabel-outlined": {
        transform: "translate(11px, 10px) scale(1)",
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px,-6px) scale(0.75)",
      },
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function SnappBoxRequest(props: any) {
  const [previewState, setPreviewState] = useState("CANCELLED" as Status);
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [latLng, setLatLng] = useState({
    lat: props.order.customerLat,
    lng: props.order.customerLon,
  } as {
    lat: number;
    lng: number;
  });
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState({} as any);
  const [description, setDescription] = useState("");
  const [waypoints, setWaypoints] = useState([
    { lat: 35.6700926, lon: 51.2933106 },
    { lat: 35.6700855, lon: 51.2942279 },
  ] as any);
  const [order, setOrder] = useState({});
  const [price, setPrice] = useState(0);
  const [deliveryCategory, setDeliveryCategory] = useState("BIKE_WITHOUT_BOX");
  const [voucherCode, setVoucherCode] = useState("");
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const classes = useStyles();

  useEffect(() => {
    getOrder();
  }, []);

  const mapStyle = {
    position: "absolute",
    top: "7px",
    right: "0",
    left: "0",
    margin: "0 auto",
    zIndex: "1000",
    minWidth: "320px",
    maxWidth: "300px",
    height: "38px",
  };

  const cancelOrder3PL = async () => {
    const payload = {
      id: props.id,
      body: { description: "" },
      callback: () => {
        cancelRequest();
      },
    };
    try {
      setLoading(true);
      const { response, callback } = await ordersRepository.cancel3PLItems({
        payload,
      });
      handleNotfication("درخواست پیک مورد نظر با موفقیت لغو شد ", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const cancelRequest = () => {
    setOpenAlopeykRequest(false);
  };

  const handlerDriver = () => {
    setOpenAlopeykRequest(true);
    makeUpdate3PL();
  };

  const makeUpdate3PL = async () => {
    const tpl = {
      customerName:
        order.customerName + "-" + order.id + "-" + order.partnerName,
      customerMobileNumber: order.customerMobileNumber,
      customerAddress: order.customerAddress,
      latitude: latLng.lat,
      longitude: latLng.lng,
      deliveryCategory,
      voucherCode,
    };
    try {
      const response = await TPSRepository.getSnappBoxPrice({ payload: tpl });
      setPrice(response.data.finalCustomerFare);
      response.data.voucherMessage &&
        response.data.voucherMessage !== "SUCCESS" &&
        handleNotfication(response.data.voucherMessage, "error");
      setOpenAlopeykRequest(false);
    } catch (error) {
      handleError(error);
      setOpenAlopeykRequest(false);
    }
  };

  const submit3PL = async () => {
    const body = {
      orderIds: [...props.orderId],
      tplCode: "SNAPP_BOX",
      snappBoxDeliveryCategory: deliveryCategory,
      snappBoxVoucherCode: voucherCode,
    };
    const orderBody = {
      ...props.order,
      customerLat: latLng.lat,
      customerLon: latLng.lng,
      isChangedLabelFile: false,
      isChangedReceiptFile: false,
    };
    try {
      setOpenAlopeykRequest(true);
      await ordersRepository.updateOrder({ payload: { body: orderBody } });
      const { response } = await ordersRepository.setOrders3PL({
        payload: { body },
      });
      setOpenAlopeykRequest(false);
      props.onClose();
    } catch (error) {
      setOpenAlopeykRequest(false);
      handleError(error);
    }
  };

  const getOrder = () => {
    const { orderId } = props;
    getOrderWithId(orderId);
  };

  const getOrderWithId = async (id: string) => {
    try {
      const response = await ordersRepository.getOrderWithId({
        payload: { id },
      });
      setOrder(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  const changeStatusOrder = async () => {
    const { id } = props;
    try {
      await ordersRepository.updateOrderStatus({
        payload: {
          id: order.id,
          body: previewState.replace(/"/g, ""),
          pagination: {},
          callback: () => getOrderWithId(id),
        },
      });
      handleClose();
    } catch (error) {
      handleError(error);
    }
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  useEffect(() => {
    setLatLng({ lat: props.order.customerLat, lng: props.order.customerLon });
  }, [props.order]);

  return (
    <Grid className={classes.root}>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {"نام سفارش‌دهنده:  "}
              </span>

              <span>{order.customerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {"شماره همراه سفارش‌دهنده:  "}
              </span>
              <span>{formaterPhoneNumber(order.customerMobileNumber)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {"استان:  "}
              </span>
              <span>{formaterPhoneNumber(order.customerProvince)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCityVariantOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {"شهر:  "}
              </span>
              <span>{formaterPhoneNumber(order.customerCity)}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {"کد پستی:  "}
              </span>
              <span>{formaterPhoneNumber(order.customerZipCode)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {"تعداد بسته:  "}
              </span>
              <span>{order?.orderPackages?.length}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {"تاریخ تحویل سفارش:  "}
              </span>
              <span>
                {order.deliveryDate &&
                  `${jMoment(order.deliveryDate, "YYYY/MM/DD")
                    .locale("fa")
                    .format("jYYYY/jMM/jDD")}`}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {"ساعت تحویل سفارش:  "}
              </span>
              <span>
                {`${jMoment(order.deliveryStartTime, "HH:mm:ss")
                  .locale("fa")
                  .format("HH:mm")}`}
                {` - ${jMoment(order.deliveryEndTime, "HH:mm:ss")
                  .locale("fa")
                  .format("HH:mm")}`}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={7}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {"آدرس سفارش‌دهنده:  "}
              </span>
              <span>{order.customerAddress && order.customerAddress}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={5}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPaperRollOutline}
                  size={1}
                  className={classes.icon}
                />
                {"توضیحات:  "}
              </span>
              <span>{order.description && order.description}</span>
            </div>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiSendCircleOutline}
                  size={1}
                  className={classes.rtlIcon}
                />
                {"نوع ارسال:  "}
              </span>
              <span>{translate(order?.deliveryType)}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {"تعداد آیتم های سفارش:  "}
              </span>
              <span>{order?.items?.length}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <RadioGroup
        row
        aria-label="gender"
        name="gender1"
        value={deliveryCategory}
        onChange={(e) => setDeliveryCategory(e.target.value)}>
        <FormControlLabel
          value="BIKE_WITHOUT_BOX"
          control={<Radio />}
          label="پیک بدون جعبه"
        />
        <FormControlLabel
          value="BIKE"
          control={<Radio />}
          label="پیک با جعبه"
        />
        <FormControlLabel value="VAN" control={<Radio />} label="وانت سبک" />
        <FormControlLabel
          value="VAN_HEAVY"
          control={<Radio />}
          label="وانت سنگین"
        />
      </RadioGroup>
      <Grid item xs={12} style={{ position: "relative" }}>
        {waypoints.length !== 0 && (
          <StaticMap
            style={{
              height: "700px",
              position: "relative",
              zIndex: 1,
            }}
            zoom={14}
            center={{
              lat: props.order.customerLat || 35.7219,
              lon: props.order.customerLon || 51.3347,
            }}
            position={{
              lat: props.order.customerLat || 35.7219,
              lon: props.order.customerLon || 51.3347,
            }}
            draggable={false}
          />
        )}
        <Grid className={classes.requestDetailCard}>
          <h4>{"درخواست پیک"}</h4>
          <Divider className={classes.divider} />
          <Grid
            style={{ margin: 0 }}
            container
            justify="space-between"
            alignItems="center">
            <Grid item>
              <span>{"هزینه"}</span>
            </Grid>
            <Grid item>
              <strong>
                {numberWithCommas(price?.toString())?.concat(" ", "ریال")}
              </strong>
            </Grid>
          </Grid>
          <TextField
            fullWidth
            id="voucherCode"
            name="voucherCode"
            size="small"
            variant="outlined"
            style={{ marginTop: "12px" }}
            value={voucherCode}
            onChange={(e) => setVoucherCode(e.target.value)}
            label="کدتخفیف"
          />
          <Button
            type="button"
            onClick={handlerDriver}
            className={classes.requestButton}
            aria-label="search">
            {"درخواست پیک"}
          </Button>
          <Divider className={classes.divider} />
          {price > 0 && (
            <Button
              type="button"
              onClick={submit3PL}
              className={classes.requestButton}
              aria-label="search">
              {"تایید اسنپ"}
            </Button>
          )}
        </Grid>
      </Grid>

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={""}
        content={
          <Grid
            container
            style={{ margin: 0, width: "300px" }}
            direction="column"
            spacing={4}
            alignItems="center"
            justify="center">
            <Icon
              color="#4aa8ff"
              size={3}
              path={mdiLoading}
              spin={openAlopeykRequest}
            />
            <h5 className="text-center">{"لطفا شکیبا باشید."}</h5>
            {/* <Button
              onClick={cancel3PLRequest}
              fullWidth
              color="secondary"
              variant="contained"
            >
              {'لغو درخواست'}
            </Button> */}
          </Grid>
        }
      />

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(order.status, "order")}"
        به
       " ${translate(previewState.replace(/"/g, "") as Status, "order")}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openDeleteItem} onClose={handleCloseDialog}>
        <DialogContent style={{ width: "600px" }}>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <p>
            آیا از لغو آیتم 3PL با شناسه
            <strong> {item.id} </strong> مطمئن هستید
          </p>
          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item} style={{ width: "100%" }}>
              <span className={classes.label}>
                <Icon path={mdiText} size={1} className={classes.icon} />
              </span>

              <span style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  label="توضیحات"
                  className={classes.textInput}
                />
              </span>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={cancelOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                disabled={loading || !description}>
                {"بله"}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                fullWidth
                autoFocus>
                {"خیر"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default SnappBoxRequest;
